import { css } from "@emotion/react";
import { theme } from "@/constants/theme";

export const previewSection = css({
  width: "100%",
  margin: "80px 0",
  [theme.breakpoints.down("md")]: {
    margin: "40px 0",
  },
});

export const previewTitle = css({
  textAlign: "center",
  color: theme.palette.primary.main,
  margin: "32px 0",
  padding: "0 16px",
});

export const previewGrid = css({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  gap: "1.5rem",
  width: "100%",
  padding: "0 16px",
});

export const previewItem = css({
  position: "relative",
  height: 420,
  overflow: "hidden",
  cursor: "pointer",

  img: {
    objectFit: "cover",
    transition: "transform 0.4s ease, opacity 0.4s ease",
  },

  "&:hover img": {
    transform: "scale(1.08)",
  },
});

export const imageWrapper = css({
  position: "absolute",
  inset: 0,
});

export const overlay = css({
  position: "absolute",
  inset: 0,
  zIndex: 2,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "background 0.3s ease",
  pointerEvents: "none",
});

export const overlayText = css({
  color: "#fff",
  textAlign: "center",
  textShadow: "0 2px 8px rgba(0,0,0,0.6)",
  letterSpacing: "3px",
  fontWeight: 300,
});
